import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, PaginationLinks, IconSpinner, Avatar, ReviewRating, UserDisplayName } from '../../components';
import { useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import css from './ListingPage.module.css';

const Review = props => {
  const { review, intl } = props;

  const date = review?.attributes?.createdAt;
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });

  return (
    <div className={css.review}>
      <div className={css.reviewHeader}>
        <div className={css.avatarNname}>
          <Avatar className={css.avatar} user={review.author} />
          <UserDisplayName user={review.author} intl={intl} />
        </div>


        <ReviewRating
          rating={review?.attributes?.rating}
          className={css.mobileReviewRating}
          reviewStarClassName={css.reviewRatingStar}
        />
      </div>
      <div>
        <p className={css.reviewContent}>{review?.attributes?.content}</p>
        {/* <p className={css.reviewInfo}>
          {dateString}
        </p> */}
      </div>
    </div>
  );
};
const Reviews = props => {
  const intl = useIntl();
  const { className, rootClassName, reviews = [] } = props;
  const classes = classNames(rootClassName || css.root, className);

  return reviews?.length ? (
    <ul className={classes}>
      {reviews?.map(r => {
        return (
          <li key={`Review_${r.id.uuid}`} className={css.reviewItem}>
            <Review review={r} intl={intl} />
          </li>
        );
      })}
    </ul>
  ) : null;
};


const SectionReviews = props => {
  const {
    reviews = [],
    fetchReviewsError,
    fetchReviewsInProgress,
    page = 1,
    perPage = 5,
    pageName,
    pagePathParams,
    pageSearchParams = {},
  } = props;

  const totalPages = Math.max(1, Math.ceil((reviews.length || 0) / perPage));
  const safePage = Math.min(Math.max(parseInt(page, 10) || 1, 1), totalPages);
  const start = (safePage - 1) * perPage;
  const end = start + perPage;
  const displayedReviews = reviews.slice(start, end);

  return (
    <section id="reviews" className={css.sectionReviews}>
      {/* <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
      </Heading> */}
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : fetchReviewsInProgress ? (
        <IconSpinner />
      ) : (
        <div className={css.reviewsContainer}>
          <Reviews reviews={displayedReviews} />
          {reviews.length > perPage && pageName ? (
            <PaginationLinks
              pageName={pageName}
              pagePathParams={pagePathParams}
              pageSearchParams={pageSearchParams}
              pagination={{ page: safePage, totalPages }}
              hash="#reviews"
            />
          ) : null}
        </div>
      )}
    </section>
  );
};

export default SectionReviews;
